import React, { useState, useEffect } from 'react';
import InputAdornment from '@mui/material/InputAdornment';
import { TextField } from '@mui/material';
import Button from '@mui/material/Button';
import connect from "react-redux/es/components/connect";
import translate from "../i18n/translate";
import { actionToggleFooter, actionToggleNavBar, actionToggleSideBar } from "../store/action/LayoutActionSupervisor";
import { client, getAccessRightsForPageID, actionGetAgathaConfigurationList } from "../store/action/RemoteActionSupervisor";
import { PAGEID, ACCESSRIGHTSTYPE } from "../i18n/constants";
import { getMultiLanguageMessage } from "../i18n/multiLanguage";

let BASE_URL = process.env.REACT_APP_SERVER_URL_API;

const AgathaConfiguration = (props) => {
    const [language, setLanguage] = useState("");
    const [pageAccessRights, setPageAccessRights] = useState({});
    const [agathaConfigurationList, setAgathaConfigurationList] = useState([]);
    const [isButtonClicked, setIsButtonClicked] = useState(false);
    const [changeStatus, setChangeStatus] = useState(false); //Trigger page rendering
    const [isSubmitSuccess, setIsSubmitSuccess] = useState(false);

    const handleAgathaConfigValueChange = (e, index) => {
        if (index < 0 || agathaConfigurationList.length <= index || !e) return;
        let inputVal = e.target.value;
        if (parseInt(agathaConfigurationList[index].ConfigDataType) === 2) {
            inputVal = inputVal.replace(/[^0-9]/g, "");
        } else if (parseInt(agathaConfigurationList[index].ConfigDataType) === 3) {
            inputVal = inputVal.replace(/[^0-9.]/g, "");
        }
        agathaConfigurationList[index].NewConfigValue = inputVal;
        setChangeStatus(!changeStatus);
    };

    const updateAgathaConfig = async () => {
        let index = 0;
        let isModified = false;
        let agathaConfig = {};
        for (index = 0; index < agathaConfigurationList.length; index++) {
            agathaConfig = agathaConfigurationList[index];
            agathaConfigurationList[index].IsModified = false;
            if (agathaConfig.NewConfigValue && agathaConfig.NewConfigValue !== '') {
                if (parseInt(agathaConfig.ConfigDataType) === 1 && agathaConfig.ConfigValue != agathaConfig.NewConfigValue) {
                    isModified = true;
                    agathaConfigurationList[index].IsModified = true;
                } else if ((parseInt(agathaConfig.ConfigDataType) === 2 || parseInt(agathaConfig.ConfigDataType) === 3) &&
                    parseFloat(agathaConfig.ConfigValue) !== parseFloat(agathaConfig.NewConfigValue)) {
                    isModified = true;
                    agathaConfigurationList[index].IsModified = true;
                }
            }
        }
        if (!isModified) {
            alert(getMultiLanguageMessage('msg_NoChangesMade_Error', language));
            return;
        }

        if (window.confirm(getMultiLanguageMessage('msg_Update_Confirm', language))) {
            setIsButtonClicked(true);
            let adminId = localStorage.getItem("supervisorid");
            let isError = false;
            for (index = 0; index < agathaConfigurationList.length; index++) {
                agathaConfig = agathaConfigurationList[index];
                if (!agathaConfig.IsModified) {
                    continue;
                }

                const params = {
                    VfaspID: process.env.REACT_APP_VFASP_CODE,
                    AdminID: adminId,
                    ConfigType: agathaConfig.ConfigType,
                    ConfigValue: agathaConfig.NewConfigValue
                };
                await client(localStorage.getItem("supervisortoken")).put(`${BASE_URL}/agathaconfig/update`, params).then((response) => {
                    props.actionGetAgathaConfigurationList();
                    setIsSubmitSuccess(true);
                }).catch(error => {
                    alert(getMultiLanguageMessage('msg_Server_Error', language));
                    setIsSubmitSuccess(false);
                    isError = true;
                });
                if (isError) {
                    break;
                }
            }
            setIsButtonClicked(false);
        }
    };

    useEffect(() => {
        if (props?.agathaConfigurationList?.length > 0) {
            setAgathaConfigurationList(props.agathaConfigurationList);
        }
    }, [props.agathaConfigurationList]);

    useEffect(() => {
        if (props?.supervisor?.length > 0) {
        }
    }, [props.supervisor]);

    useEffect(() => {
        let selectedLanguage = localStorage.getItem("locale");
        setLanguage(selectedLanguage);
        let accessRights = getAccessRightsForPageID(PAGEID.AgathaConfig);
        setPageAccessRights(accessRights);
        if (accessRights && accessRights.ReadAccess === ACCESSRIGHTSTYPE.Yes) {
            props.actionGetAgathaConfigurationList();
        } else {
            alert(getMultiLanguageMessage('Msg_InvalidAccessRights', selectedLanguage));
        }
    }, []);

    return ((props?.supervisor?.length > 0 && pageAccessRights && pageAccessRights.ReadAccess === ACCESSRIGHTSTYPE.Yes)) ? (
        <div className="user-panel">
            <h2 className="user-panel-title">{translate('Menu-AgathaConfiguration')}</h2>

            {/* .nav-tabs-line */}
            <div className="tab-content" id="security-opt-tab">
                {/* .tab-pane */}
                <div className="tab-pane active show" id="password-opt">
                    <form action="#">
                        {/* .row */}

                        <table width='100%'>
                            <tbody>
                                {agathaConfigurationList?.map((agathaConfig, index) => {
                                    return <tr key={agathaConfig.AUTORECID}>
                                        <td className='td-type2-col1'>{agathaConfig.ConfigName}</td>
                                        <td className='td-type2-col2'>
                                            <TextField
                                                size="small"
                                                id={"id_AgathaConfig" + index}
                                                sx={{ width: '24.5ch' }}
                                                value={agathaConfigurationList[index].NewConfigValue}
                                                onChange={event => handleAgathaConfigValueChange(event, index)}
                                            />
                                        </td>
                                    </tr>
                                })}
                            </tbody>
                        </table>

                        {isButtonClicked &&
                            <>
                                <div className="gaps" />
                                <img width={80} src={require('../assets/images/loading.gif')} srcSet={require('../assets/images/loading.gif')} alt="loading" />
                            </>
                        }
                        <div className="gaps-2x" />
                        <div className="d-sm-flex justify-content-between align-items-center">
                            <div className="gaps-2x d-sm-none" />
                            <span className="color-success">
                                {isSubmitSuccess &&
                                    <div>
                                        <em className="ti ti-check-box" /> {translate('Update-Success-Message')}
                                        <div className="gaps-1x" />
                                    </div>
                                }
                            </span>
                        </div>

                        {pageAccessRights.WriteAccess === ACCESSRIGHTSTYPE.Yes &&
                            <div className="d-sm-flex justify-content-between align-items-center">
                                <Button variant="contained" size='large' disabled={isButtonClicked ? true : false} onClick={() => updateAgathaConfig()}>{translate('btnUpdate')}</Button>
                                <div className="gaps-2x d-sm-none" />
                            </div>
                        }
                    </form>
                    {/* form */}
                </div>
                {/* .tab-pane */}
            </div>
            {/* .tab-content */}
        </div>
    ) : '';
};

const mapStateToProps = state => {
    return {
        navBar: state.siteLayout.navBar,
        supervisor: state.remote.supervisor,
        agathaConfigurationList: state.remote.agathaConfigList
    };
};

export default connect(mapStateToProps, {
    actionToggleNavBar,
    actionToggleSideBar,
    actionToggleFooter,
    actionGetAgathaConfigurationList
})(AgathaConfiguration);
